<template>
  <v-navigation-drawer
    permanent
    :rail="!isOpen"
    location="right"
    elevation="3"
    color="primary-darken-2"
    theme="dark"
  >
    <!-- Logo at the top -->
   
    
    <!-- Title -->
    <div class="text-center mt-2 mb-5 py-2" v-if="isOpen">
      <h2 class="text-subtitle-1 font-weight-bold">منظومة المراسلات</h2>
    </div>
    
    <v-divider color="rgba(255, 255, 255, 0.1)" class="mb-2"></v-divider>
    
    <!-- Compose Button -->
    <div class="px-2 mb-4">
      <v-btn
        
        block
        color="white"
        class="compose-btn"
        prepend-icon="mdi-pencil"
          @click="$emit('compose')"
      >
        <span v-if="isOpen">إنشاء مراسلة</span>
      </v-btn>
    </div>
    
    <!-- Navigation items -->
    <v-list nav density="compact">
      <!-- Dashboard - accessible to all users -->
      <v-list-item
        to="/dashboard"
        prepend-icon="mdi-view-dashboard"
        title="لوحة التحكم"
        value="dashboard"
        class="rtl-list-item"
      ></v-list-item>
      
      <v-divider class="my-2" color="rgba(255, 255, 255, 0.1)"></v-divider>
      
      <v-list-item
        v-if="hasModule('mails')"
        to="/dashboard/inbox"
        prepend-icon="mdi-inbox"
        title="البريد الوارد"
        value="inbox"
        class="rtl-list-item"
      ></v-list-item>
      
      <v-list-item
        v-if="hasModule('mails')"
        to="/dashboard/sent"
        prepend-icon="mdi-send"
        title="البريد الصادر"
        value="sent"
        class="rtl-list-item"
      ></v-list-item>
      
      <v-list-item
        v-if="hasModule('archive-mails')"
        to="/dashboard/archive"
        prepend-icon="mdi-archive"
        title="الأرشيف"
        value="archive"
        class="rtl-list-item"
      ></v-list-item>
      
      <v-list-item
        v-if="hasModule('mails')"
        to="/dashboard/drafts"
        prepend-icon="mdi-file-document-outline"
        title="المسودات"
        value="drafts"
        class="rtl-list-item"
      ></v-list-item>
      
      <v-divider 
        v-if="hasAnyAdminModule"
        class="my-2" 
        color="white"
      ></v-divider>
      
      <v-list-item
        v-if="hasModule('departments')"
        to="/dashboard/departments"
        prepend-icon="mdi-office-building"
        title="الإدارات"
        value="departments"
        class="rtl-list-item"
      ></v-list-item>
      
      <v-list-item
        v-if="hasModule('users')"
        to="/dashboard/users"
        prepend-icon="mdi-account-group"
        title="إدارة المستخدمين"
        value="users"
        class="rtl-list-item"
      ></v-list-item>
      
      <v-list-item
        v-if="hasModule('mail-templates')"
        to="/dashboard/templates"
        prepend-icon="mdi-file-document-multiple"
        title="قوالب الرسائل"
        value="templates"
        class="rtl-list-item"
      ></v-list-item>
      
      <v-list-item
        v-if="hasModule('marginalizations')"
        to="/dashboard/notes"
        prepend-icon="mdi-note-text"
        title="التهميشات"
        value="notes"
        class="rtl-list-item"
      ></v-list-item>
      
      <v-divider 
        v-if="hasAnySettingsModule"
        class="my-2" 
        color="white"
      ></v-divider>
      
      <!-- Settings Group -->
      <v-list-group v-if="hasAnySettingsModule" value="settings">
        <template v-slot:activator="{ props }">
          <v-list-item
            v-bind="props"
            prepend-icon="mdi-cog"
            title="الإعدادات"
            class="rtl-list-item"
          ></v-list-item>
        </template>
        
        <v-list-item
          v-if="hasModule('mail-priorities')"
          to="/dashboard/settings/mail-priorities"
          prepend-icon="mdi-flag"
          title="أولويات المراسلات"
          value="mail-priorities"
          class="rtl-list-item settings-child"
        ></v-list-item>
        
        <v-list-item
          v-if="hasModule('roles')"
          to="/dashboard/settings/roles"
          prepend-icon="mdi-account-multiple"
          title="إدارة الأدوار"
          value="roles"
          class="rtl-list-item settings-child"
        ></v-list-item>
        
        <v-list-item
          v-if="hasModule('mail-types')"
          to="/dashboard/settings/mail-types"
          prepend-icon="mdi-email-variant"
          title="أنواع المراسلات"
          value="mail-types"
          class="rtl-list-item settings-child"
        ></v-list-item>
        
        <v-list-item
          v-if="hasModule('file-types')"
          to="/dashboard/settings/file-types"
          prepend-icon="mdi-file-multiple"
          title="أنواع المرفقات"
          value="file-types"
          class="rtl-list-item settings-child"
        ></v-list-item>
        
        <v-list-item
          v-if="hasModule('department-jobs')"
          to="/dashboard/settings/department-jobs"
          prepend-icon="mdi-briefcase"
          title="المناصب الإدارية"
          value="department-jobs"
          class="rtl-list-item settings-child"
        ></v-list-item>
        
        <v-list-item
          v-if="hasModule('employee-titles')"
          to="/dashboard/settings/employee-titles"
          prepend-icon="mdi-account-tie"
          title="المسميات الوظيفية"
          value="employee-titles"
          class="rtl-list-item settings-child"
        ></v-list-item>
        
        <v-list-item
          v-if="hasModule('mail-template-categories')"
          to="/dashboard/settings/mail-template-categories"
          prepend-icon="mdi-folder-multiple"
          title="فئات القوالب"
          value="mail-template-categories"
          class="rtl-list-item settings-child"
        ></v-list-item>
      </v-list-group>
    </v-list>
    
    <!-- Spacer to push compose button to bottom -->
    <v-spacer></v-spacer>
    
    <!-- Bottom Compose Button -->
  
  </v-navigation-drawer>
</template>

<script>
import { PERMISSIONS, hasPermission, hasModule } from '@/utils/permissions'

export default {
  name: 'AppSidebarComponent',
  props: {
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  emits: ['compose'],
  
  computed: {
    PERMISSIONS() {
      return PERMISSIONS
    },
    
    hasAnyAdminModule() {
      // Prevent permission checks during logout to avoid DOM errors
      if (this.$store.state.isLoggingOut) {
        return false
      }
      
      const adminModules = ['departments', 'users', 'marginalizations', 'settings']
      return adminModules.some(module => this.hasModule(module))
    },

    hasAnySettingsModule() {
      // Prevent permission checks during logout to avoid DOM errors
      if (this.$store.state.isLoggingOut) {
        return false
      }
      const settingsModules = [
        'mail-priorities',
        'roles',
        'mail-types',
        'file-types',
        'department-jobs',
        'employee-titles',
        'mail-template-categories'
      ]
      return settingsModules.some(module => this.hasModule(module))
    }
  },
  
  methods: {
    hasPermission(permission) {
      // Prevent permission checks during logout to avoid DOM errors
      if (this.$store.state.isLoggingOut) {
        return false
      }
      return hasPermission(permission)
    },
    
    hasModule(moduleName) {
      // Prevent permission checks during logout to avoid DOM errors
      if (this.$store.state.isLoggingOut) {
        return false
      }
      return hasModule(moduleName)
    }
  }
}
</script>

<style scoped>
.rtl-list-item :deep(.v-list-item__prepend) {
  margin-left: 8px;
  margin-right: 0;
}

.rtl-list-item :deep(.v-list-item__content) {
  text-align: right;
}

.v-navigation-drawer--rail .rtl-list-item :deep(.v-list-item__content) {
  opacity: 0;
}

/* Make sure the logo is visible even when sidebar is collapsed */
.v-navigation-drawer--rail :deep(.v-avatar) {
  margin-right: 0;
}

.sidebar-header {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.sidebar-logo {
  background-color: white;
  padding: 2px;
  border-radius: 50%;
}

/* Improve active item styling */
:deep(.v-list-item--active) {
  background-color: rgba(255, 255, 255, 0.15) !important;
}

:deep(.v-list-item:hover) {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

:deep(.v-list-item__overlay) {
  background-color: transparent !important;
}

.compose-button-wrapper {
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  padding: 8px 0;
  background: linear-gradient(to top, rgba(62, 66, 102, 1) 0%, rgba(62, 66, 102, 0) 100%);
}

.compose-btn {
  height: 48px !important;
  font-weight: 500;
  letter-spacing: 0.25px;
  text-transform: none;
}

.v-navigation-drawer--rail .compose-btn {
  min-width: 0;
  padding: 0 !important;
  justify-content: center;
}

.v-navigation-drawer--rail .compose-btn .v-btn__prepend {
  margin-inline-end: 0;
}

/* Settings child items styling */
.settings-child {
 
  background-color: rgba(255, 255, 255, 0.05) !important;
}

.settings-child:hover {
  background-color: rgba(255, 255, 255, 0.15) !important;
}

.settings-child.v-list-item--active {
  background-color: rgba(255, 255, 255, 0.2) !important;
}

/* Fix nested list-item padding in RTL */
:deep(.v-list-group__items .v-list-item) {
  padding-inline-start: 16px !important; /* for LTR */
  padding-inline-end: 16px !important;   /* for RTL */
}

:deep(.rtl-list-item .v-list-item__content) {
  text-align: right !important;
  padding-right: 16px !important; /* force text inside drawer */
  padding-left: 0 !important;
}

/* Optional: tighter spacing for child items */
.settings-child {
  padding-inline-start: 24px !important;
  padding-inline-end: 24px !important;
}
</style> 